export const LOCATIONS = [
  {
    slug: "mansa",
    name: "Mansa",
    tagline: "Our home city.",
    intro:
      "Mansa is where Click World Online was founded in 2017 and where our office sits today. We work hands-on with local businesses — retailers, clinics, schools and service providers — who want their online presence to match the reputation they've built offline.",
    industries: ["Retail & Local Shops", "Healthcare & Clinics", "Education & Coaching", "Agriculture & Agri-business", "Restaurants & Hospitality", "Real Estate"],
    marketNote:
      "In Mansa, most customers discover businesses on their phones — through Google Maps, search and WhatsApp. A complete Google Business Profile and a fast, mobile-friendly website matter more here than anywhere.",
    faqs: [
      {
        q: "Do you work with small local businesses in Mansa?",
        a: "Yes — most of our longest relationships are with Mansa businesses. Being based here, we can meet in person, understand your market directly and respond quickly.",
      },
      {
        q: "How fast can my Mansa business appear on Google?",
        a: "A well-optimised Google Business Profile can start appearing within days of verification. Website and SEO results build over weeks and months — we'll give you an honest timeline after reviewing your situation.",
      },
      {
        q: "Can you visit our shop or office in Mansa?",
        a: "Absolutely. For Mansa businesses we prefer face-to-face discovery — it makes the strategy sharper. 360° photography shoots are done on-site as well.",
      },
      {
        q: "Do you provide website development services in Mansa?",
        a: "Yes — websites are one of our core services for Mansa businesses, designed and built by our local team.",
        link: { label: "Website development in Mansa", to: "/website-development/mansa" },
      },
      {
        q: "Can businesses in Mansa hire Click World Online for digital marketing?",
        a: "Yes — strategy, social media, advertising and lead generation for Mansa businesses, planned around local seasons and audiences.",
        link: { label: "Digital marketing in Mansa", to: "/digital-marketing/mansa" },
      },
      {
        q: "Can you improve my Mansa business's visibility on Google?",
        a: "Yes — local SEO and Google Business Profile management are among our most-used services in Mansa, and our own 4.7-star Mansa profile is proof we practice it.",
        link: { label: "SEO services in Mansa", to: "/seo-services/mansa" },
      },
    ],
  },
  {
    slug: "bathinda",
    name: "Bathinda",
    tagline: "The commercial heart of Malwa.",
    intro:
      "Bathinda's business scene is bigger and more competitive — coaching institutes, hospitals, showrooms and industry all compete for the same searches. We help Bathinda businesses stand out with sharper positioning and conversion-focused digital work.",
    industries: ["Coaching & Education", "Hospitals & Healthcare", "Retail Showrooms", "Industrial & Manufacturing", "Hotels & Hospitality", "Automobile Dealers"],
    marketNote:
      "Bathinda customers compare before they call. Searches like 'best coaching in Bathinda' or 'hospital near me' are genuinely contested — winning them takes SEO, reviews and advertising working together.",
    faqs: [
      {
        q: "How do you support Bathinda clients from Mansa?",
        a: "Bathinda is a short drive from our Mansa office. Strategy sessions can happen in person, and day-to-day work runs smoothly over calls and WhatsApp.",
      },
      {
        q: "Can you manage admission-season campaigns for institutes?",
        a: "Yes — timed Google and Meta campaigns around admission windows are among the most effective plays in Bathinda's education market.",
      },
      {
        q: "Do you build websites for Bathinda showrooms?",
        a: "Yes — including catalogue-style sites, WhatsApp enquiry flows and 360° showroom tours that let customers browse before visiting.",
      },
    ],
  },
  {
    slug: "chandigarh",
    name: "Chandigarh",
    tagline: "Premium market, premium standards.",
    intro:
      "Chandigarh and the tri-city region set a higher bar — customers research deeply and expect polished brands. We help Chandigarh businesses meet that bar with portfolio-grade websites and campaigns built for a competitive, design-aware market.",
    industries: ["Real Estate", "Clinics & Wellness", "Education & Training", "Professional Services", "Restaurants & Cafés", "IT & Startups"],
    marketNote:
      "In the tri-city, digital competition is intense and ad costs run higher. Creative quality and landing-page experience decide whether a click becomes an enquiry or an expense.",
    faqs: [
      {
        q: "Do you take on Chandigarh clients remotely?",
        a: "Yes. Most tri-city engagements run remotely with scheduled strategy calls — delivery, reporting and communication stay exactly the same.",
      },
      {
        q: "Can you match the design standards Chandigarh customers expect?",
        a: "Premium, spacious, conversion-focused design is how we build everything — the website you're on right now is the standard we hold ourselves to.",
      },
      {
        q: "Do you run ads in the tri-city?",
        a: "Yes — Google and Meta campaigns targeted by sector, audience and geography across Chandigarh, Mohali and Panchkula.",
      },
    ],
  },
  {
    slug: "mohali",
    name: "Mohali",
    tagline: "Where Punjab's new economy is being built.",
    intro:
      "Mohali's IT parks, startups and new residential colonies mean new businesses launching constantly — each needing a digital presence that looks established from day one. We help Mohali ventures launch fast without looking rushed.",
    industries: ["IT & Startups", "Real Estate", "Fitness & Gyms", "Education", "Healthcare", "Food & Cloud Kitchens"],
    marketNote:
      "Mohali buyers skew young and digital-first. Social proof, an active Instagram presence and strong Google reviews carry real weight in purchase decisions here.",
    faqs: [
      {
        q: "We're a new Mohali startup — where should we start?",
        a: "Usually: one sharp website, a complete Google Business Profile, and a single focused channel done well — rather than five channels done thinly.",
      },
      {
        q: "Can you handle branding and website together?",
        a: "Yes — identity, website and launch campaigns are often bundled for new Mohali businesses so everything launches consistently.",
      },
      {
        q: "Do you offer ongoing monthly support?",
        a: "Yes — most Mohali clients run monthly retainers covering content, advertising and continuous improvement.",
      },
    ],
  },
  {
    slug: "punjab",
    name: "Punjab",
    tagline: "One team. The whole state.",
    intro:
      "From Ludhiana to Amritsar, Patiala to Jalandhar — we serve businesses across Punjab with the same strategy-first process, delivered remotely or on-site. Distance changes nothing about the quality of the work.",
    industries: ["Exporters & Manufacturers", "Education Groups", "Healthcare Chains", "Hotels & Tourism", "E-commerce", "Agriculture & Food Processing"],
    marketNote:
      "Punjab's businesses increasingly sell beyond Punjab. Digital is how a Mansa manufacturer reaches a Mumbai buyer — or a Dubai one.",
    faqs: [
      {
        q: "Do you serve all of Punjab?",
        a: "Yes — our 360° virtual tour work alone spans dozens of Indian cities, and marketing engagements run statewide.",
      },
      {
        q: "How do remote projects work?",
        a: "Discovery over a call, strategy in writing, regular updates on WhatsApp or email, and clear monthly reporting.",
      },
      {
        q: "Can you manage multi-location visibility?",
        a: "Yes — for businesses with multiple branches we manage location-wise Google profiles and local SEO at scale.",
      },
    ],
  },
];

export const SERVICE_AREAS = [
  {
    service: "website-development",
    city: "mansa",
    keyword: "Website Development Agency in Mansa",
    baseService: "website-design-development",
    intro:
      "Looking for a website development agency in Mansa that treats your business as more than a template? We're based here — your website is planned, designed and built by the same local team you can sit across the table from.",
    angle:
      "Most Mansa customers will see your site on a phone, often on a modest connection. Every website we build here is mobile-first, fast on real networks, and wired for WhatsApp and call enquiries — not just a digital visiting card.",
    focus: ["Mobile-first business websites", "WhatsApp & call enquiry integration", "Google Maps & profile connection", "Fast loading on budget devices"],
    faqs: [
      { q: "What does a business website cost in Mansa?", a: "Every project is scoped individually — a focused business website usually costs far less than people expect. Share your requirement and we'll quote honestly, without packages full of things you don't need." },
      { q: "How long does a website take?", a: "Most Mansa business websites launch within two to four weeks, depending mainly on how quickly content and photos are ready." },
      { q: "Will you update the site after launch?", a: "Yes — simple monthly care plans cover updates, or we hand over a site your own team can edit." },
    ],
  },
  {
    service: "digital-marketing",
    city: "mansa",
    keyword: "Digital Marketing Agency in Mansa",
    baseService: "digital-marketing-strategy",
    intro:
      "Digital marketing in Mansa works when it's built around how people here actually discover businesses — Google Maps, WhatsApp, and word-of-mouth that now starts online. As a Mansa-based agency, that local reality shapes every campaign we run.",
    angle:
      "From retailers around the main markets to clinics and academies across the city, we plan campaigns in the language and style your customers respond to — Punjabi, Hindi or English — and time them around local seasons and festivals.",
    focus: ["Google Maps & local search visibility", "Social media that speaks local", "Festival & seasonal campaign planning", "WhatsApp-first enquiry flows"],
    faqs: [
      { q: "Is digital marketing worth it for a small Mansa business?", a: "Yes — local campaigns can run on modest budgets because the audience is focused. The key is starting with the right one or two channels instead of spreading thin." },
      { q: "Which platforms matter most in Mansa?", a: "For most local businesses: Google (search + Maps), WhatsApp, and Instagram or Facebook. We confirm the mix after understanding your customers." },
      { q: "When will I see results?", a: "Ads and Google Business Profile work can bring enquiries within weeks. Organic search and social presence build over months. We set expectations honestly at the start." },
    ],
  },
  {
    service: "seo-services",
    city: "mansa",
    keyword: "SEO Services in Mansa",
    baseService: "seo",
    intro:
      "When someone in Mansa searches for what you sell, your business should be the name they see. Our SEO services in Mansa focus on local intent — the searches that end in a phone call, a direction request or a store visit.",
    angle:
      "Local SEO here isn't generic keyword stuffing. It's a complete Google Business Profile, a steady flow of genuine reviews, Mansa-specific pages and content, and a website that loads fast on the connections people actually use.",
    focus: ["Local keyword research for Mansa searches", "Google Business Profile optimisation", "Review & reputation building", "On-page and technical fixes"],
    faqs: [
      { q: "Can you guarantee a #1 ranking?", a: "No honest agency can. What we guarantee is disciplined, transparent work — and regular reporting so you can see visibility improving month by month." },
      { q: "How is local SEO different from normal SEO?", a: "Local SEO targets map results and 'near me' searches — driven by your Google profile, reviews and location signals, not just website content." },
      { q: "How long does SEO take in Mansa?", a: "Local markets are less crowded than metros, so meaningful movement often shows within two to four months of consistent work." },
    ],
  },
  {
    service: "google-business-profile",
    city: "mansa",
    keyword: "Google Business Profile Services in Mansa",
    baseService: "google-business-profile",
    intro:
      "For a Mansa business, your Google Business Profile is often the first impression — before your website, before your shopfront. We set up, verify, optimise and manage profiles that turn Maps searches into calls and walk-ins.",
    angle:
      "We practice what we preach: our own Mansa profile carries a 4.7-star rating. Photos, posts, Q&A, services, categories and a genuine review strategy — every element handled properly, month after month.",
    focus: ["Profile setup, verification & categories", "Review generation strategy", "Photos, posts & Q&A management", "Map ranking & insights reporting"],
    faqs: [
      { q: "My business isn't on Google Maps — can you fix that?", a: "Yes — we handle creation, verification and complete setup, including correct categories, hours, photos and services." },
      { q: "Can you help get more reviews?", a: "Yes — we set up an ethical review flow that makes it easy for happy customers to leave genuine feedback. We never buy or fake reviews." },
      { q: "What if my profile is suspended or has wrong info?", a: "Profile reinstatement and correction is a common job for us — we handle the verification and appeal process with Google." },
    ],
  },
  {
    service: "local-seo",
    city: "mansa",
    keyword: "Local SEO Services in Mansa",
    baseService: "local-seo",
    intro:
      "Local SEO is how Mansa businesses own 'near me' and city searches. It connects your Google Business Profile, your website and your reviews into one system that keeps you visible when nearby customers are ready to buy.",
    angle:
      "Because we're based in Mansa, we know which searches actually matter here — and which are vanity. Our local SEO plans concentrate effort where enquiries actually come from.",
    focus: ["Mansa-specific keyword targeting", "Citation & listing consistency", "Location pages & local content", "Map pack visibility work"],
    faqs: [
      { q: "What's included in a local SEO plan?", a: "Google Business Profile management, on-site local optimisation, listing and citation cleanup, review strategy and monthly visibility reporting." },
      { q: "Do I need a website for local SEO?", a: "A Google profile alone can bring calls, but a proper website multiplies results — it gives every search a convincing place to land." },
      { q: "Is local SEO a one-time job?", a: "Setup is one-time; staying on top isn't. Competitors, reviews and Google's algorithm keep moving, so ongoing care keeps you ahead." },
    ],
  },
  {
    service: "website-development",
    city: "bathinda",
    keyword: "Website Development Agency in Bathinda",
    baseService: "website-design-development",
    intro:
      "Bathinda's market rewards businesses that look established online. We build websites for Bathinda's retailers, institutes, hospitals and industrial firms that turn comparison-shoppers into enquiries.",
    angle:
      "In a city where customers check three options before calling one, your website has roughly seconds to build trust. Our builds lead with proof, clarity and instant contact options — designed for how Bathinda buys.",
    focus: ["Conversion-focused business websites", "Institute & admission enquiry systems", "Catalogue & showroom websites", "Speed and mobile optimisation"],
    faqs: [
      { q: "Do you work with Bathinda coaching institutes?", a: "Yes — admission-season landing pages, course catalogues and enquiry systems are a common build for Bathinda's education market." },
      { q: "Can you rebuild our existing outdated website?", a: "Yes — most projects are rebuilds. We keep what works, fix what doesn't, and relaunch without losing your search presence." },
      { q: "Is support available after launch?", a: "Yes — Bathinda clients get the same monthly care and quick WhatsApp support as our Mansa clients." },
    ],
  },
  {
    service: "digital-marketing",
    city: "bathinda",
    keyword: "Digital Marketing Agency in Bathinda",
    baseService: "digital-marketing-strategy",
    intro:
      "In Bathinda's competitive education, healthcare and retail markets, timing and targeting decide who wins the customer. We plan and run digital marketing for Bathinda businesses that treats every rupee as an investment to be accounted for.",
    angle:
      "Admission seasons, festival retail rushes, hospital awareness campaigns — Bathinda has clear commercial rhythms. Our campaigns are planned around them, with creative that doesn't look like everyone else's.",
    focus: ["Admission & seasonal campaigns", "Google & Meta advertising", "Reputation & review strategy", "Content for local audiences"],
    faqs: [
      { q: "What budget do Bathinda campaigns need?", a: "It depends on your sector's competition — education and healthcare are pricier than local retail. We'll model realistic budgets before you commit anything." },
      { q: "Can you run campaigns only during admission season?", a: "Yes — seasonal bursts are common, though an always-on presence usually lowers your cost per enquiry over time." },
      { q: "Do you handle creatives too?", a: "Yes — design, copy, photo and video content are all produced in-house so campaigns launch fast and stay consistent." },
    ],
  },
  {
    service: "seo-services",
    city: "bathinda",
    keyword: "SEO Services in Bathinda",
    baseService: "seo",
    intro:
      "Bathinda's searches are genuinely contested — institutes, hospitals and showrooms all investing in visibility. Our SEO services for Bathinda businesses combine technical fixes, content and local signals into steady, compounding visibility.",
    angle:
      "We don't chase vanity keywords. We map the searches Bathinda customers actually make — 'best', 'near me', price and course queries — and build pages and profiles that deserve to rank for them.",
    focus: ["Competitive keyword mapping", "Technical & on-page SEO", "Local pack optimisation", "Content that answers real queries"],
    faqs: [
      { q: "How competitive is SEO in Bathinda?", a: "More competitive than smaller cities, less than metros — which means disciplined work still wins within a realistic timeframe." },
      { q: "Can you outrank institutes with bigger budgets?", a: "Often, yes — search rewards relevance and consistency, not just spend. Local specificity is a genuine advantage." },
      { q: "What will I receive each month?", a: "A plain-language report: what was done, what moved, and what's next. No jargon, no inflated graphs." },
    ],
  },
  {
    service: "website-development",
    city: "chandigarh",
    keyword: "Website Development Services in Chandigarh",
    baseService: "website-design-development",
    intro:
      "Tri-city customers judge fast and expect polish. Our website development services for Chandigarh businesses deliver portfolio-grade design with the performance and conversion structure underneath that actually produces enquiries.",
    angle:
      "Chandigarh's design-aware audience notices details — typography, spacing, load speed. We build to that standard because it's the standard we hold for our own site, which you're reading right now.",
    focus: ["Premium brand-grade websites", "Real estate & professional service sites", "Landing pages for ad campaigns", "Core Web Vitals performance"],
    faqs: [
      { q: "Do you meet Chandigarh clients in person?", a: "Kickoff and strategy sessions can be in person; ongoing work runs smoothly over scheduled calls and shared reports." },
      { q: "Can you match international design trends?", a: "Yes — our design language follows current international agency standards, adapted to your brand rather than copied from templates." },
      { q: "Do you build landing pages for agencies' clients?", a: "Yes — we also white-label builds for Chandigarh agencies needing extra development capacity." },
    ],
  },
  {
    service: "digital-marketing",
    city: "chandigarh",
    keyword: "Digital Marketing Agency in Chandigarh",
    baseService: "digital-marketing-strategy",
    intro:
      "Chandigarh's ad auctions are pricier and its audiences more skeptical. As a digital marketing agency serving Chandigarh, our edge is creative quality and landing experience — the two levers that decide whether expensive clicks become profitable customers.",
    angle:
      "Sector-wise targeting across the tri-city, creative that stops mid-scroll, and landing pages built to convert — we run Chandigarh campaigns as connected systems, not isolated ads.",
    focus: ["Tri-city audience targeting", "Creative-led Meta campaigns", "High-intent Google search campaigns", "Landing experience optimisation"],
    faqs: [
      { q: "Are Chandigarh ad costs higher?", a: "Generally yes — which is exactly why creative quality and conversion rate matter more than raw budget there." },
      { q: "Can you target specific sectors of the city?", a: "Yes — Meta and Google both allow tight geographic and interest targeting across sectors and nearby towns." },
      { q: "Do you report on real business outcomes?", a: "We track enquiries and leads as the primary metric — impressions and likes are context, not goals." },
    ],
  },
  {
    service: "local-seo",
    city: "punjab",
    keyword: "Local SEO Services in Punjab",
    baseService: "local-seo",
    intro:
      "One Punjab, many distinct markets. Our local SEO services for Punjab businesses build city-wise visibility — the right profiles, pages and content for each location you serve, in the language customers actually search in.",
    angle:
      "Statewide visibility isn't one profile multiplied. It's Mansa retail searches, Ludhiana B2B queries and Amritsar tourist lookups — each handled with its own local signals and content.",
    focus: ["Multi-city Google profile management", "City-wise landing pages", "Regional language content strategy", "Statewide citation consistency"],
    faqs: [
      { q: "Can one strategy cover all our Punjab branches?", a: "One framework, yes — but each branch gets its own profile, reviews flow and location content. Shared templates underperform in local search." },
      { q: "Do you create Punjabi-language content?", a: "Yes — where your audience searches in Punjabi or Hindi, we plan content accordingly rather than forcing English everywhere." },
      { q: "How is multi-location reporting handled?", a: "You get a single monthly view with per-location breakdowns — calls, direction requests and rankings by city." },
    ],
  },
];

export const getLocation = (slug) => LOCATIONS.find((l) => l.slug === slug);
export const getServiceArea = (service, city) =>
  SERVICE_AREAS.find((a) => a.service === service && a.city === city);
export const areasForCity = (city) => SERVICE_AREAS.filter((a) => a.city === city);

export const AREAS_FOR_SERVICE = {
  "website-design-development": [
    { label: "Mansa", path: "/website-development/mansa" },
    { label: "Bathinda", path: "/website-development/bathinda" },
    { label: "Chandigarh", path: "/website-development/chandigarh" },
  ],
  "digital-marketing-strategy": [
    { label: "Mansa", path: "/digital-marketing/mansa" },
    { label: "Bathinda", path: "/digital-marketing/bathinda" },
    { label: "Chandigarh", path: "/digital-marketing/chandigarh" },
  ],
  seo: [
    { label: "Mansa", path: "/seo-services/mansa" },
    { label: "Bathinda", path: "/seo-services/bathinda" },
  ],
  "local-seo": [
    { label: "Mansa", path: "/local-seo/mansa" },
    { label: "Punjab", path: "/local-seo/punjab" },
  ],
  "google-business-profile": [{ label: "Mansa", path: "/google-business-profile/mansa" }],
};

export const AREA_LABELS = {
  "website-development": "Website Development",
  "digital-marketing": "Digital Marketing",
  "seo-services": "SEO Services",
  "local-seo": "Local SEO",
  "google-business-profile": "Google Business Profile",
};
